import * as React from 'react';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

type TextInputType = 'text' | 'number';

interface IProps {
    type        : TextInputType;
    id          : string;
    label       : string;
    value       : any;
    onChange    : any;
    className?  : string;
    error?      : any;
    disable?    : boolean;
    isOptional? : boolean;
    isLoading?  : boolean;
    name?       : string;
    onBlur?     : any;
    onKeyDown?  : any;
    placeholder?: string;
    testID?     : string;
}

// #endregion

const TextInput : React.SFC<IProps> = (props) => {

    const { 
        className, 
        id, 
        error, 
        label, 
        type, 
        value, 
        onChange, 
        disable, 
        isLoading,
        name,
        onBlur,
        onKeyDown,
        placeholder,
        testID
    } = props;

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <input
                id={id}
                className={"form-control" + ( error ? ' error-outline' : '')}
                type={type}
                name={name}
                autoComplete="off"
                placeholder={ placeholder }
                disabled={disable}
                value={value}
                onKeyDown={ onKeyDown }
                onBlur={ onBlur }
                onChange={onChange}
                data-testid={ testID }
            />
            <div className={"autocomplete__three-dots in-input " + ( isLoading ? 'show' : '')}>
                <div className="dot1" />
                <div className="dot2" />
                <div className="dot3" />
            </div>
            <InputFeedback error={error} />
        </div>
    );
};

TextInput.defaultProps = {
    className   : '',
    error       : undefined,
    disable     : false,
    isOptional  : false,
    isLoading   : false,
    name        : '',
    onBlur      : undefined,
    onKeyDown   : undefined,
    placeholder : '',
    testID      : ''
};

export { TextInput };
